import { useState, useEffect } from 'react'
import Layout from '../../layout'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { formateDate, capitalizeFirstLetter } from '../../helpers/commonFunctions';
import Sorting from '../../components/common/sorting';
import Loader from '../../components/common/loader'
import Breadcrums from '../../components/common/breadcrumbs'
import CustomPagination from '../../components/common/customPaginationAdmin'
import { GetZatcaOnboardingRequests, ApproveZatcaOnboardingRequest } from '../../services/outletManagementService'
import ViewAllDetails from './viewAllDetails'
import notFound from '../../assets/company/img/no-record-found.png'
import Swal from 'sweetalert2'

const ZatcaOnboardingRequests = () => {

    const breadcrumbs = [
        { title: "Dashboard", url: "/admin/dashboard" },
        { title: "Companies", url: "/admin/company/list/1" },
        { title: "ZATCA Onboarding Requests", url: "" }
    ]
    const params = useParams()
    const location = useLocation()
    const [list, setList] = useState([])
    const [dataLength, setDataLength] = useState()
    const [itemPerPage] = useState(10)
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true)
    const [search, setSearch] = useState({})
    const [globalSearch, setGlobalSearch] = useState("")

    const companyId = params.id;

    const fetchList = () => {
        setLoader(true)
        const formData = new FormData()
        formData.append("page", params.pgno)
        formData.append("per_page", itemPerPage)
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append("company_id", companyId)
        GetZatcaOnboardingRequests(formData).then(data => {
            setDataLength(data.data.response.count);
            setList(data?.data?.response?.rows || [])
            setLoader(false)
        }).catch(error => {
            console.log("error ====> ", error);
            setLoader(false)
        })
    }

    useEffect(() => {
        fetchList()
    }, [location, sorting, search, globalSearch])

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    const handleApprove = (row) => {
        Swal.fire({
            title: 'Approve Request?',
            text: `Approve ZATCA onboarding for "${row.configuration_name || 'this configuration'}"?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Approve',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                const formData = new FormData()
                formData.append("id", row.id)
                formData.append("status", true)
                formData.append("company_id", companyId)
                ApproveZatcaOnboardingRequest(formData).then(() => {
                    Swal.fire({ icon: 'success', title: 'Approved', text: 'Onboarding request approved successfully.', timer: 2000, showConfirmButton: false })
                    fetchList()
                }).catch(error => {
                    console.log("error ====> ", error);
                    Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to approve request.' })
                })
            }
        })
    }

    const handleReject = (row) => {
        Swal.fire({
            title: 'Reject Request?',
            text: `Reject ZATCA onboarding for "${row.configuration_name || 'this configuration'}"?`,
            icon: 'warning',
            input: 'textarea',
            inputLabel: 'Rejection Reason',
            inputPlaceholder: 'Enter reason for rejection...',
            inputAttributes: { 'aria-label': 'Rejection reason' },
            inputValidator: (value) => { if (!value) return 'Please provide a rejection reason.' },
            showCancelButton: true,
            confirmButtonText: 'Reject',
            confirmButtonColor: '#d33',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                const formData = new FormData()
                formData.append("id", row.id)
                formData.append("status", false)
                formData.append("rejected_reason", result.value)
                formData.append("company_id", companyId)
                ApproveZatcaOnboardingRequest(formData).then(() => {
                    Swal.fire({ icon: 'success', title: 'Rejected', text: 'Onboarding request rejected.', timer: 2000, showConfirmButton: false })
                    fetchList()
                }).catch(error => {
                    console.log("error ====> ", error);
                    Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to reject request.' })
                })
            }
        })
    }

    return (
        <Layout>
            <Breadcrums data={breadcrumbs} />
            <div className="animation_fade">
                <div className="card custom-card overflow-hidden">
                    <div className="card-body">
                        <ViewAllDetails tab='zatca-onboarding' />
                        <div className='d-flex justify-content-between align-items-center mb-4'>
                            <div className='d-flex align-items-center'>
                                <div className='form-group mb-0 me-3'>
                                    <div className="form-group mb-0 rangepicker_container">
                                        <i className="fa fa-search calender_icon"></i>
                                        <input type="search" className="form-control" value={globalSearch} placeholder="Search" onChange={(e) => { setGlobalSearch(e.target.value) }} />
                                    </div>
                                </div>
                                <button type="reset" value='Reset' onClick={() => { setGlobalSearch(""); setSearch({}); }} className="btn btn-warning float-right mr-2">Reset Filter</button>
                            </div>
                        </div>
                        <div className="tabler-wrap">
                            <div className="table-responsive">
                                <table className="table table-custom">
                                    <thead>
                                        <tr>
                                            <th width="12%">
                                                <div className='sorting_column'>
                                                    <span>Brand</span>
                                                </div>
                                            </th>
                                            <th width="12%">
                                                <div className='sorting_column'>
                                                    <span>Outlet</span>
                                                </div>
                                            </th>
                                            <th width="14%">
                                                <div className='sorting_column'>
                                                    <span>Configuration Name</span>
                                                    <Sorting sort={sorting} handleSort={handleSort} column="configuration_name" />
                                                </div>
                                            </th>
                                            <th width="10%">Type</th>
                                            <th width="14%">Device Name</th>
                                            <th width="10%">Environment</th>
                                            <th width="10%">
                                                <div className='sorting_column'>
                                                    <span>Created At</span>
                                                    <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="created_at" />
                                                </div>
                                            </th>
                                            {/* <th width="8%">Status</th> */}
                                            <th className='action_head' width="10%">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loader ? (
                                            <tr><td colSpan={9}><Loader /></td></tr>
                                        ) : (
                                            <>
                                                {list.length ? list.map((row, i) => (
                                                    <tr key={row.id || i}>
                                                        <td>{capitalizeFirstLetter(row?.outlet?.brand?.name) || 'N/A'}</td>
                                                        <td>{capitalizeFirstLetter(row?.outlet?.outlet_name) || 'N/A'}</td>
                                                        <td>{row.configuration_name || 'N/A'}</td>
                                                        <td>
                                                            <span className={`badge ${row.configuration_type === 'pos' ? 'bg-primary' : 'bg-info'}`} style={{ fontSize: '0.78rem' }}>
                                                                {row.configuration_type ? row.configuration_type.toUpperCase() : 'N/A'}
                                                            </span>
                                                        </td>
                                                        <td>{row?.outlet_hardware_detail?.name || 'N/A'}</td>
                                                        <td>
                                                            {row?.zatca_details?.zatca_environment_type ? (
                                                                <span className={`badge ${row.zatca_details.zatca_environment_type === 'production' ? 'bg-success' : 'bg-warning text-dark'}`} style={{ fontSize: '0.78rem' }}>
                                                                    {capitalizeFirstLetter(row.zatca_details.zatca_environment_type)}
                                                                </span>
                                                            ) : 'N/A'}
                                                        </td>
                                                        <td>{row.created_at ? formateDate(row.created_at) : 'N/A'}</td>
                                                        {/* <td>
                                                            {row.zatca_onboarding_requested_approved ? (
                                                                <span className="badge bg-success" style={{ fontSize: '0.78rem' }}>Approved</span>
                                                            ) : (
                                                                <span className="badge bg-warning text-dark" style={{ fontSize: '0.78rem' }}>Pending</span>
                                                            )}
                                                        </td> */}
                                                        <td>
                                                            <div className="d-flex gap-1">
                                                               <button className="btn btn-sm btn-success" onClick={() => handleApprove(row)}>Approve</button>
                                                                <button className="btn btn-sm btn-danger" onClick={() => handleReject(row)}>Reject</button>   
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )) : (
                                                    <tr>
                                                        <td colSpan={9} className="text-center">
                                                            <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                            <p>No records</p>
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className='tabler-footer'>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <div id="example1_info" role="status" className="table-result" aria-live="polite">
                                        <b>Total Records : {dataLength || "0"}</b>
                                    </div>
                                    {dataLength && dataLength > 0 ?
                                        <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "zatca-onboarding", path: `/admin/company/zatca-onboarding/${params.id}` }]} /> : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default ZatcaOnboardingRequests
